const STYLES = {
  PENDING_VERIFICATION: "bg-amber-50 text-amber-700 border border-amber-200",
  APPROVED: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  REJECTED: "bg-red-50 text-red-700 border border-red-200",
  CHANGES_REQUESTED: "bg-amber-50 text-amber-700 border border-amber-200",
  PENDING_APPROVAL: "bg-amber-50 text-amber-700 border border-amber-200",
  DRAFT: "bg-stone-100 text-stone-700 border border-stone-300",
  SUBMITTED_FOR_APPROVAL: "bg-blue-50 text-blue-700 border border-blue-200",
  CHANGES_REQUIRED: "bg-amber-50 text-amber-700 border border-amber-200",
  FINALIZED: "bg-purple-50 text-purple-700 border border-purple-200",
  SHARED: "bg-purple-50 text-purple-700 border border-purple-200",
  QUEUED: "bg-stone-100 text-stone-700 border border-stone-300",
  PROCESSING: "bg-blue-50 text-blue-700 border border-blue-200",
  SUCCESS: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  FAILED: "bg-red-50 text-red-700 border border-red-200",
  EXTRACTING: "bg-blue-50 text-blue-700 border border-blue-200",
  REVIEW: "bg-amber-50 text-amber-700 border border-amber-200",
  PUBLISHING: "bg-blue-50 text-blue-700 border border-blue-200",
  PUBLISHED: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  DISCARDED: "bg-stone-100 text-stone-500 border border-stone-300",
};

export default function StatusBadge({ status }) {
  const style = STYLES[status] || "bg-stone-100 text-stone-700 border border-stone-300";
  return (
    <span
      data-testid="status-badge"
      className={`px-3 py-1 rounded-full text-xs font-semibold tracking-wide uppercase inline-flex items-center gap-1.5 ${style}`}
    >
      {status?.replace(/_/g, " ")}
    </span>
  );
}
